module.exports = __webpack_public_path__ + "static/media/AssetHead.376b5dd0.png";